// extracted by mini-css-extract-plugin
export default {"container":"Home_container__SrM0+","banner":"Home_banner__FF6NC","bannerText":"Home_bannerText__c+V0P","footer":"Home_footer__ZzlCa","logoContainer":"Home_logoContainer__2ob4j"};